import React, { useEffect, useRef } from "react";

const CustomModal = ({ show, onClose, title, children, width = 720, style }) => {
  const modalRef = useRef();

  useEffect(() => {
    if (show && modalRef.current) {
      // Trigger animation
      requestAnimationFrame(() => {
        modalRef.current.classList.add("custom-modal-content--open");
      });
    }
    return () => {
      if (modalRef.current) {
        modalRef.current.classList.remove("custom-modal-content--open");
      }
    };
  }, [show]);

  if (!show) return null;
  return (
    <div className="custom-modal-backdrop">
      <div
        ref={modalRef}
        className="custom-modal-content"
        style={{ maxWidth: width, ...style }}
      >
        <button onClick={onClose} className="custom-modal-close">&times;</button>
        {title && <h4 className="custom-modal-title">{title}</h4>}
        {children}
      </div>
      <style>{`
        .custom-modal-backdrop {
          position: fixed;
          top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.5);
          z-index: 1050;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: fadeInBackdrop 0.3s ease-in-out;
        }
        @keyframes fadeInBackdrop {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .custom-modal-content {
          background: #fff;
          border-radius: 12px;
          width: 100%;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          padding: 23px;
          margin:20px;
          position: relative;
          opacity: 0;
          transform: scale(0.9) translateY(20px);
          transition: opacity 0.3s ease, transform 0.3s ease;
        }
        .custom-modal-content--open {
          opacity: 1;
          transform: scale(1) translateY(0);
        }
        .custom-modal-close {
          position: absolute;
          top: 16px;
          right: 16px;
          background: none;
          border: none;
          font-size: 1.5rem;
          color: #666;
          cursor: pointer;
          transition: color 0.2s;
        }
        .custom-modal-close:hover {
          color: #333;
        }
        .custom-modal-title {
          margin-bottom: 24px;
          font-weight: bold;
          font-size: 1.5rem;
          color: #333;
        }
      `}</style>
    </div>
  );
};

export default CustomModal;